import apiV2 from "@/apiConfig/api-v2";

export const changePassword = async (data) => {
  return await apiV2.put("/users/change-password", data);
};
